export default __webpack_public_path__ + "static/media/map-view.5b5b30a7.svg";